import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    List,
    ListItemButton,
    ListItemText,
    Paper,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { TokenContext } from '../Context/TokenContext';

const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080';

/**
 * Chaque logiciel a ses propres CGU (pas de CGU générique du site) — on
 * choisit d'abord le logiciel ici, avant d'atteindre son éditeur dédié.
 */
export default function CGUListPage() {
    const navigate = useNavigate();
    const { accessToken } = useContext(TokenContext);

    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchApplications = useCallback(() => {
        if (!accessToken) return;
        setLoading(true);
        axios.get(`${API_URL}/api/applications`, { headers: { Authorization: `Bearer ${accessToken}` } })
            .then((res) => setApplications(res.data))
            .catch(() => setError('Impossible de charger les logiciels'))
            .finally(() => setLoading(false));
    }, [accessToken]);

    useEffect(() => { fetchApplications(); }, [fetchApplications]);

    return (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/settings')}
                sx={{ mb: 2 }}
            >
                Retour aux réglages
            </Button>

            <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold', mb: 1, fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>
                Conditions générales d&apos;utilisation
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Chaque logiciel a ses propres CGU. Choisissez-en un pour éditer les siennes.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2, maxWidth: 560 }}>{error}</Alert>}

            <Paper variant="outlined" sx={{ maxWidth: 560 }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress size={28} /></Box>
                ) : (
                    <List disablePadding>
                        {applications.map((app) => (
                            <ListItemButton
                                key={app.client_id}
                                divider
                                onClick={() => navigate(`/settings/cgu/${app.client_id}`)}
                            >
                                <ListItemText primary={app.name} secondary={app.client_id} />
                                <ChevronRightIcon color="disabled" />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Paper>
        </Box>
    );
}
